export const LAYOUT = {
  TOGGLE_SIDEBAR_DESKTOP: "TOGGLE_SIDEBAR_DESKTOP",
  TOGGLE_SIDEBAR_MOBILE: "TOGGLE_SIDEBAR_MOBILE",
  SET_SIDEBAR: "SET_SIDEBAR",
  SET_LOADING: "SET_LOADING",
  SET_COUNTING: "SET_COUNTING"
};

export const SET_LOCALE = "SET_LOCALE";

export const AUTH = {
  AUTH_LOGIN: "AUTH_LOGIN",
  AUTH_LOGOUT: "AUTH_LOGOUT",
  AUTH_REFRESH_TOKEN: "AUTH_REFRESH_TOKEN",
  FETCH_AUTH: "FETCH_AUTH",
  SET_CALLBACK_URL: "SET_CALLBACK_URL"
};

export const EMPLOYEE = {
  FETCH_EMPLOYEE: "FETCH_EMPLOYEE",
  SHOW_EMPLOYEE: "SHOW_EMPLOYEE",
  CREATE_EMPLOYEE: "CREATE_EMPLOYEE",
  UPDATE_EMPLOYEE: "UPDATE_EMPLOYEE",
  GET_EMPLOYEE: "GET_EMPLOYEE",
  GET_INFO_EMPLOYEE: "GET_INFO_EMPLOYEE"
};

export const COMMONS = {
  FOOTS: "FOOTS",
  DIVISIONS: "DIVISIONS",
  POSITIONS: "POSITIONS",
  JOBTITLE: "JOBTITLE",
  WORKTYPE: "WORKTYPE",
  COMPANIES: "COMPANIES",
  NOTIFICATIONS: "NOTIFICATIONS",
  QUANTITYREQUEST: "QUANTITYREQUEST",
  LEAVEVALUE: "LEAVEVALUE",
  COMMONVALUE: "COMMONVALUE",
  APPROVAL_PERSON: "APPROVAL_PERSON",
  SUBMITTED_INFORMATION: "SUBMITTED_INFORMATION",
  ADMINS: "ADMINS"
};

export const CHART = {
  MEMBER_COMPANIES: "MEMBER_COMPANIES",
  MEMBER_FOOTS: "MEMBER_FOOTS",
  MEMBER_DIVISIONS: "MEMBER_DIVISIONS",
  MEMBER_JOB_TITLE: "MEMBER_JOB_TITLE",
  MEMBER_IN_OUT: "MEMBER_IN_OUT"
};

export const CUSTOMER = {
  FETCH_CUSTOMER: "FETCH_CUSTOMER",
  DETAIL_CUSTOMER: "DETAIL_CUSTOMER",
  EDIT_CUSTOMER: "EDIT_CUSTOMER",
  UPDATE_CUSTOMER: "UPDATE_CUSTOMER",
  CREATE_CUSTOMER: "CREATE_CUSTOMER"
};
export const PROJECT = {
  FETCH_PROJECT: "FETCH_PROJECT",
  PROJECT_DETAIL: "PROJECT_DETAIL",
  GET_EMPLOYEE: "GET_EMPLOYEE",
  EMPLOYEES: "EMPLOYEES",
  CUSTOMERS: "CUSTOMERS",
  EMPLOYEE_POSITION: "EMPLOYEE_POSITION",
  GET_DETAIL_PROJECT: "GET_DETAIL_PROJECT",
  PROJECT_STATUS: "PROJECT_STATUS"
};

export const TIMESHEET = {
  FETCH_TIMESHEET: "FETCH_TIMESHEET",
  DETAIL_TIMESHEET: "DETAIL_TIMESHEET",
  FETCH_TIMESHEET_REQUEST: "FETCH_TIMESHEET_REQUEST",
  FETCH_TIMESHEET_EXPORT: "FETCH_TIMESHEET_EXPORT",
  FETCH_TIMESHEET_TODAY: "FETCH_TIMESHEET_TODAY",
  FETCH_TIMESHEET_DASHBOARD: "FETCH_TIMESHEET_DASHBOARD",
  FETCH_TIMESHEET_TOTAL_REQUEST: "FETCH_TIMESHEET_TOTAL_REQUEST"
};

export const OVERTIME_REQUEST = {
  GET_INFO_OVER_TIME: "GET_INFO_OVER_TIME",
  GET_PROJECTS_EMPLOYEES_OVER_TIME: "GET_PROJECTS_EMPLOYEES_OVER_TIME",
  SHOW_OVER_TIME_REQUEST_APPROVAL: "SHOW_OVER_TIME_REQUEST_APPROVAL",
  FETCH_OVERTIME_REQUEST: "FETCH_OVERTIME_REQUEST",
  FETCH_OVERTIME_REQUEST_EXPORT: "FETCH_OVERTIME_REQUEST_EXPORT",
  SHOW_OVERTIME_REQUEST: "SHOW_OVERTIME_REQUEST",
  FETCH_OVERTIME_REQUEST_APPROVAL: "FETCH_OVERTIME_REQUEST_APPROVAL",
  COMMON_PROJECT: "COMMON_PROJECT",
  GET_APPROVAL_PERSON: "GET_APPROVAL_PERSON",
  LIST_OVERTIME_REQUEST_ALL_APPROVAL: "LIST_OVERTIME_REQUEST_ALL_APPROVAL",
  GET_EXPIRE_SABBATICAL: "GET_EXPIRE_SABBATICAL",
  GET_EXPIRE_SABBATICAL_LOG: "GET_EXPIRE_SABBATICAL_LOG",
  GET_EXPIRE_SABBATICAL_LEAVE: "GET_EXPIRE_SABBATICAL_LEAVE",
  GET_DASHBOARD_EXPIRE_SABBATICAL: "GET_DASHBOARD_EXPIRE_SABBATICAL",
  CLEAR_DATA: "CLEAR_DATA"
};

export const ADDITIONAL_TIMESHEET = {
  IS_ADMIN: "IS_ADMIN",
  CREATE_ADDITIONAL_TIMESHEET: "CREATE_ADDITIONAL_TIMESHEET",
  EDIT_ADDITIONAL_TIMESHEET: "EDIT_ADDITIONAL_TIMESHEET",
  APPROVAL_ADDITIONAL_TIMESHEET: "APPROVAL_ADDITIONAL_TIMESHEET",
  LIST_APPROVAL_ADDITIONAL_TIMESHEET: "LIST_APPROVAL_ADDITIONAL_TIMESHEET",
  FETCH_ADDITIONAL_TIMESHEET: "FETCH_ADDITIONAL_TIMESHEET",
  SHOW_ADDITIONAL_TIMESHEET: "SHOW_ADDITIONAL_TIMESHEET"
};

export const SABBATICAL_LEAVE_REQUEST = {
  FETCH_SABBATICAL_LEAVE_REQUEST: "FETCH_SABBATICAL_LEAVE_REQUEST",
  FETCH_SABBATICAL_LEAVE_APPROVAL: "FETCH_SABBATICAL_LEAVE_APPROVAL",
  DETAIL_SABBATICAL_LEAVE_REQUEST: "DETAIL_SABBATICAL_LEAVE_REQUEST",
  COMMON_REASONS: "COMMON_REASONS",
  GET_DATA_COMMON: "GET_DATA_COMMON",
  GET_INFO_SABBATICAL: "GET_INFO_SABBATICAL",
  SHOW_SABBATICAL_REQUEST_APPROVAL: "SHOW_SABBATICAL_REQUEST_APPROVAL",
  GET_CALCULATE_DAY_LEAVE: "GET_CALCULATE_DAY_LEAVE",
  LIST_SABBATICAL_REQUEST_ALL_APPROVAL: "LIST_SABBATICAL_REQUEST_ALL_APPROVAL",
  GET_EXPIRE_SABBATICAL_LOG: "GET_EXPIRE_SABBATICAL_LOG",
  GET_EXPIRE_SABBATICAL_LEAVE: "GET_EXPIRE_SABBATICAL_LEAVE",
  GET_EXPIRE_SABBATICAL: "GET_EXPIRE_SABBATICAL"
};
export const SKILLSHEET = {
  FETCH_SKILLSHEET: "FETCH_SKILLSHEET",
  GET_ALL_SKILLS: "GET_ALL_SKILLS",
  GET_EMPLOYEE_SKILLS: "GET_EMPLOYEE_SKILLS"
};
export const SEAT_EMPLOYEE = {
  LIST_SEAT_EMPLOYEE: "LIST_SEAT_EMPLOYEE"
};

// Check point type
export const CHECKPOINT = {
  REVIEW_PROCESS: "REVIEW_PROCESS",
  SET_REVIEW_LIST: "SET_REVIEW_LIST",
  SET_LEFT_MENU: "SET_LEFT_MENU",
  SET_REVIEW_FORM_PROP: "SET_REVIEW_FORM_PROP",
  RESULT_MEMBER: "RESULT_MEMBER"
};

export const NEW = {
  NEW_LIST: "NEW_LIST",
  CATEGORY: "CATEGORY",
  NEW_DETAIL: "NEW_DETAIL"
};
export const SUMMERTRIPVOTE = {
  START: "START",
  END: "END",
  GET_VOTE_STATUS: "GET_VOTE_STATUS",
  GET_VOTES: "GET_VOTES",
  GET_TIMEOUT: "GET_TIMEOUT",
  RESET: "RESET"
};
export const REMOTE = {
  REMOTE_REQUEST_LIST: "REMOTE_REQUEST_LIST",
  REMOTE_APPROVAL_REQUEST_LIST: "REMOTE_APPROVAL_REQUEST_LIST",
  GET_USER_REMOTE_INFO: "GET_USER_REMOTE_INFO",
  CLEAR_DATA: "CLEAR_DATA",
  GET_REMOTE_REQUEST_INFO: "GET_REMOTE_REQUEST_INFO",
  GET_APPROVAL_REMOTE_REQUEST_INFO: "GET_APPROVAL_REMOTE_REQUEST_INFO"
};

export const SHORT_LEAVE_REQUEST = {
  FETCH_SHORT_LEAVE_REQUEST: "FETCH_SHORT_LEAVE_REQUEST",
  SET_PAGINATION: "SET_PAGINATION"
};
